global.fetch = fetch

const ua = navigator.userAgent.toLowerCase()
const isSafari = (
  (ua.indexOf('safari') != -1) && 
  (!(ua.indexOf('chrome')!= -1) && 
    (ua.indexOf('version/')!= -1))
)
const isChromium = window.chrome;
const winNav = window.navigator;
const vendorName = winNav.vendor;
const isOpera = typeof window.opr !== "undefined";
const isIEedge = winNav.userAgent.indexOf("Edge") > -1;
const isIOSChrome = winNav.userAgent.match("CriOS");

function supportsHEVCAlpha() {
  const navigator = window.navigator;
  const hasMediaCapabilities = !!(
    navigator.mediaCapabilities && navigator.mediaCapabilities.decodingInfo
  )
  return isSafari && hasMediaCapabilities
}

export {
  supportsHEVCAlpha,
  isIOSChrome,
  isSafari,
}
